import React, { useEffect, useState } from 'react';
import Grid from '@material-ui/core/Grid';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  LabelList,
} from 'recharts';
import { MuiPickersUtilsProvider, DatePicker } from '@material-ui/pickers';
import DateFnsUtils from '@date-io/date-fns';
import ptBrLocale from 'date-fns/locale/pt-BR';
import { makeStyles } from '@material-ui/core/styles';
import { COLORS } from '../../consts/common';

function Barra({ updateValue, getInfoUsers, title, data, date, barInfo }) {
  const useStyles = makeStyles((theme) => ({
    cards: {
      padding: '10px',
    },
  }));

  const classes = useStyles();

  useEffect(() => {
    updateValue(date);
  }, []);

  return (
    <Grid container direction="row" justify="center" alignItems="center">
      <Box borderRadius={16}>
        <Grid
          container
          direction="row"
          justify="space-between"
          alignItems="stretch"
          className={classes.cards}
        >
          <Grid item>
            <Typography variant="h5" gutterBottom>
              {title}
            </Typography>
          </Grid>
          <Grid item>
            <MuiPickersUtilsProvider utils={DateFnsUtils} locale={ptBrLocale}>
              <DatePicker
                views={['year']}
                label="Ano"
                format="yyyy"
                value={date}
                onChange={updateValue}
                InputAdornmentProps={{ position: 'start' }}
                inputVariant="outlined"
              />
            </MuiPickersUtilsProvider>
          </Grid>
        </Grid>
        <BarChart
          width={1200}
          height={300}
          data={data}
          onClick={(b) => {
            if (getInfoUsers) {
              const id_usuario = b.activePayload[0]
                ? title.includes('Assinantes')
                  ? b.activePayload[0].payload.id_usuario_assinante
                  : b.activePayload[0].payload.id_usuario
                : [];
              getInfoUsers(id_usuario);
            }
          }}
          margin={{ top: 15, bottom: 5 }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="periodo" />
          <YAxis />
          <Tooltip />
          <Legend />
          {barInfo.map((b, i) => (
            <Bar
              type="monotone"
              dataKey={b.datakey}
              fill={COLORS[i % COLORS.length]}
              name={b.name}
              stackId={b.stackId}
            >
              <LabelList dataKey={b.label} position="top" />
            </Bar>
          ))}
        </BarChart>
      </Box>
    </Grid>
  );
}

export default Barra;
